import { render } from "./OneRevDialog.vue?vue&type=template&id=1373a9b5"
import script from "./OneRevDialog.vue?vue&type=script&lang=js"
export * from "./OneRevDialog.vue?vue&type=script&lang=js"

import "./OneRevDialog.vue?vue&type=style&index=0&id=1373a9b5&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1373a9b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1373a9b5', script)) {
    api.reload('1373a9b5', script)
  }
  
  module.hot.accept("./OneRevDialog.vue?vue&type=template&id=1373a9b5", () => {
    api.rerender('1373a9b5', render)
  })

}

script.__file = "src/components/OneRevDialog.vue"

export default script